import styled from 'styled-components';

interface IRowBaseProps {
    justifyContent?: string;
}

const RowBase = styled.div<IRowBaseProps>`
    background-color: transparent;
    padding: 0px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: ${props => props.justifyContent || 'space-between'};
`

export const NoBreakRow = styled(RowBase)`
`

export const Row = styled(RowBase)`
    @media screen and (max-width: 700px) {
        flex-direction: column;
        justify-content: start;
    }
`

export const RightColumn = styled.div`
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
`